import * as moment from "moment/moment";

// Interfaz para el resultado general del schedule
export interface IResultAccounts {
  count: number;
  next: string | null;
  previous: string | null;
  results: IAccounts[];
}

export class Roles {
  name: string;


  constructor(data: { name: string;}) {
    this.name = data.name;
  }
}

export class User {
  last_login: string;


  constructor(data: { last_login: string;}) {
    this.last_login = data.last_login;
  }
}



// Clase para el resultado general del Reportm
export class ResultAccounts {
  count: number;
  next: string | null;
  previous: string | null;
  results: Accounts[];

  constructor(result?: IResultAccounts) {
    if (result) {
      this.count = result.count;
      this.next = result.next;
      this.previous = result.previous;
      this.results = result.results ? Accounts.fromObjectArray(result.results) : [];
    } else {
      this.count = 0;
      this.next = null;
      this.previous = null;
      this.results = [];
    }
  }

  static fromObject(result: IResultAccounts): ResultAccounts {
    return new ResultAccounts(result);
  }
}

// Interfaz para cada Reportm
export interface IAccounts {
  full_name: string;
  id: string;
  roleName: string;
  is_verified: boolean;
  role: { name: string; };
  user: { last_login: string; };

}

// Clase para cada Reportm
export class Accounts {
  full_name: string;
  id: string;
  role: Roles | null;
  user: User | null;
  is_verified: boolean;

  constructor(data?: IAccounts) {
    if (data) {
      this.full_name = data?.full_name ?? "";
    this.id = data?.id ?? "";
    this.role = data?.role ? new Roles(data?.role) : null;
    this.user = data?.user ? new User(data?.user) : null;

   // this.roleName = data?.role?.name ?? "";
    this.is_verified = data?.is_verified ?? false;
   
    }
  }

  static fromObject(ent: IAccounts): Accounts {
    return new Accounts(ent);
  }

  static fromObjectArray(ent: IAccounts[]): Accounts[] {
    return ent.map(item => new Accounts(item));
  }
}
